// extracted by mini-css-extract-plugin
export default {"hazTable":"HazardAccruals_hazTable__boVG4","radioLabel":"HazardAccruals_radioLabel__Cpg4Y"};